export enum RouteType {
  NORMAL,
  WAITER
}
